import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PackageState {
  isLoading: boolean;
  carePackageList: any[];
  mostPopularPackage: any[];
  mostPopularTest: any[];
  upcomingVisitList: any[];
  modalIsOpen: boolean;
  duplicateProductData: Record<string, any>;
  duplicateProductModalIsOpen: boolean;
  productAddingForPatientFlag: boolean;
  diseaseCategoryDtoList: any[];
  popularHealthCheckUpMap: Record<string, any[]>; 
  loyalty: any;
}

const packagesInitialState: PackageState = {
  isLoading: false,
  carePackageList: [],
  mostPopularPackage: [],
  mostPopularTest: [],
  upcomingVisitList: [],
  modalIsOpen: false,
  duplicateProductData: {},
  duplicateProductModalIsOpen: false,
  productAddingForPatientFlag: false,
  diseaseCategoryDtoList: [],
  popularHealthCheckUpMap: {},
  loyalty: {}
};

const packageSlice = createSlice({
  name: "packageDataReducer",
  initialState: packagesInitialState,
  reducers: {
    updatePackageData: (state, action: PayloadAction<Partial<PackageState>>) => {
      Object.assign(state, action.payload);
    },
  },
});

export const { updatePackageData } = packageSlice.actions;
export default packageSlice.reducer;
